export default <Record<string, Record<string, string[]>>>{
  sapMaterial: {
    'Bio-Acetat': ['Bioinjiziert'],
    Acetat: ['Blockacetat'],
    Kunststoff: ['Mikrofaser'],
  },
}
